import axios from 'axios';
import Cookies from 'js-cookie';
const mediaApi = axios.create({
  // baseURL: 'http://localhost:7776/api', // Replace with your backend URL
  baseURL: 'https://digitaljournaling.com',
});

// Request interceptor to add JWT token to headers
mediaApi.interceptors.request.use(
  (config) => {
    // const token = Cookies.get('jwtToken');
    // config.headers['Authorization'] = `Bearer ${token}`; 
    config.headers['Content-Type'] = 'multipart/form-data';
    return config;
  },
  (error) => Promise.reject(error)
);
// Response interceptor to handle the new API response structure
mediaApi.interceptors.response.use(
  (response) => {
try{
const { code, data } = response.data;
if (code == "00") {
    return data; // Return only the data part for easier handling in the app
} else {
    alert(data || 'Oops,Something went wrong, please try again');
    return;
  }    
}catch(err){
  alert("Something went wrong, please try again")
}
  }
);
export default mediaApi;